import { render, staticRenderFns } from "./ReturnabilityDynamic.vue?vue&type=template&id=3891b059&scoped=true"
import script from "./ReturnabilityDynamic.vue?vue&type=script&lang=js"
export * from "./ReturnabilityDynamic.vue?vue&type=script&lang=js"
import style0 from "./ReturnabilityDynamic.vue?vue&type=style&index=0&id=3891b059&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891b059",
  null
  
)

export default component.exports